/**
 * What a revision can do from where it stands, the same answer on the instance page and on the
 * revision page.
 *
 * - The desired revision: nothing, it is already the one the server should run.
 * - A draft: Apply (publishes it and makes it desired).
 * - A published revision newer than the desired one: Apply.
 * - A published revision older than the desired one: Rollback. Nothing new is created: the old
 *   revision becomes the desired one again.
 *
 * @returns {'apply' | 'rollback' | null}
 */
export function revisionAction(revision, instance) {
  if (!instance.desiredRevision) {
    return 'apply';
  }
  if (revision.id === instance.desiredRevision.id) {
    return null;
  }
  if (revision.status === 'draft' || revision.number > instance.desiredRevision.number) {
    return 'apply';
  }
  return 'rollback';
}

export const ACTION_LABEL = { apply: 'Apply', rollback: 'Roll back' };
